<template>
  <PhotoGalleryComponent :photos="this.plant.originalLabelPhotos"
                         :base-compressed-photo-url="labelCompressedPhotoPath"
                         :base-origin-photo-url="labelOriginPhotoPath"
                         :deletePhoto="deleteLabelPhoto"
                         :isAdmin="isAdmin"
                         :photo-type="`labelPhoto`"/>
</template>

<script>
import PhotoGalleryComponent from "@/components/ExhibitPageComponents/PhotoGalleryComponent.vue";
import ToastService from "@/services/toastService";
import {labelCompressedPhotoPath, labelOriginPhotoPath} from "@/helpers/siteURL";
import {deleteExhibitLabelPhotos} from "@/services/exhibitAPI";

export default {
  components: {
    PhotoGalleryComponent
  },
  data() {
    return {
      labelCompressedPhotoPath: labelCompressedPhotoPath,
      labelOriginPhotoPath: labelOriginPhotoPath,
    }
  },
  props: {
    plant: {
      type: Object,
      required: true,
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters.getIsViewAdminPanel;
    }
  },
  methods: {
    async deleteLabelPhoto(index) {
      try {
        await deleteExhibitLabelPhotos(this.$props.plant.id, index)
        this.plant.originalLabelPhotos = this.plant.originalLabelPhotos.filter((item) => this.plant.originalLabelPhotos.indexOf(item) !== index)
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    if (this.plant.originalLabelPhotos === null || this.plant.originalLabelPhotos.length === 0) {
      ToastService.toastError("Фото этикетки еще не добавлено")
    }
  }
};
</script>